
import React from "react";
import Home from "../../../components/Home/Home";

const Multiple = () => {
  return (
    <div>
      <Home></Home>
    </div>
  );
};

export default Multiple;
